<section class="view-panel-sh view-panel--padding">
    <h1 class="view-panel--header">404</h1>
</section>
